"use client";

import React, { useState } from "react";
import IconPhone from "../../components/svg/phone"
import IconEmail from "../../components/svg/email"
import IconEuro from "../../components/svg/euro"
import IconPhoneYellow from "../../components/svg/phoneYellow"
import Button from "../../components/button"
import Link from "next/link"
import { usePathname } from "next/navigation";
import Burger from "@/app/components/svg/burger";
import CallRequestForm from "@/app/components/call-request-form";
import MobileMenu from "@/app/components/mobilemenu";
import LanguageSwitcher from "@/app/components/language-swicher";
import LanguageSwitcherEn from "@/app/en/components/language-swicher";
import {getStrapiURL} from "../../../helper/image-helper";
import IconDocument from "@/app/components/svg/document";

interface HeaderProps {
    global: {
        siteEmail: string;
        sitePhone: string;
        siteLogo: {
            url: string;
        };
        instagram: string;
        facebook: string;
        youtube: string;
    }; 
    content: {
        headerTopText: string;
        headerCallButtonName: string;
        headerPriceButtonName: string;
        headerPriceButtonUrl: string;
        headerSocialTitle: string;
    }
    menu: Array<{
        name: string;
        url: string;
    }>;
    lang?: string;
}

const HeaderContent: React.FC<HeaderProps> = ({ global, content, menu, lang }) =>  {

    const pathname = usePathname();
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const isEn = pathname.startsWith("/en");

    return (
        <header className="shadow-[0_4px_16px_0_rgba(0,0,0,0.1)] bg-white sticky top-0 z-20">
            <div className="container flex justify-between py-4 max-[1200px]:hidden">
                <div className="flex items-center justify-between w-full">
                    <div className="flex items-center">
                        <p className="font-semibold font-gilroy text-base leading-[1.25] text-violet-400">{content.headerTopText}</p>
                        <a href={`tel:${global.sitePhone}`} className="ml-8 font-semibold text-base leading-[1.25] text-violet-400 flex items-center">
                            <IconPhone />
                            <span className="ml-2">{global.sitePhone}</span>
                        </a>
                        <a href={`mailto:${global.siteEmail}`} className= "ml-[24px] font-semibold font-gilroy text-base leading-[1.25] text-violet-400 flex items-center">
                            <IconEmail />
                            <span className="ml-2">{global.siteEmail}</span>
                        </a>
                    </div>
                    <div className="max-[1200px]:hidden">
                        {isEn ? <LanguageSwitcherEn /> :  <LanguageSwitcher />}
                    </div>
                </div>
            </div>
            <div className="container flex items-center py-4 border-t-2 border-dotted border-gray-200 max-[1200px]:border-0 max-[767px]:flex-wrap max-[767px]:justify-between">
                <div className="flex items-center">
                    <div className="hidden max-[1200px]:flex mr-1"  onClick={() => setIsMenuOpen(true)}>
                        <Burger />
                    </div>
                    <Link href={isEn ? '/en/' :  '/'}>
                        <img src={getStrapiURL(global.siteLogo.url)} alt="komfortflytt.se" className="h-[40px] max-[1200px]:h-[32px]"/>
                    </Link>
                </div>
                <div className="hidden max-[1200px]:flex">
                    <LanguageSwitcher />
                </div>
                <ul className="flex font-regular text-[18px] leading-[111%] text-black max-[1200px]:!hidden">
                    {menu.map((item, index) => {
                        const isActive = pathname === item.url || (isEn && pathname === `/en${item.url}`);
                        return (
                            <li 
                                key={index} 
                                className={`${isActive ? "border-yellow-500" : ""} ml-8 py-[10px] border-b-[3px] border-transparent hover:border-yellow-500 duration-300`}>
                                <Link href={isEn ? `/en${item.url}` : item.url}>
                                    {item.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
                <div className="ml-auto flex items-center gap-4 
                    max-[767px]:w-full 
                    max-[767px]:mt-[10px] 
                    max-[767px]:pt-[10px] 
                    max-[767px]:border-dotted 
                    max-[767px]:border-gray-200 
                    max-[767px]:border-t-2
                    max-[576px]:justify-between
                    "
                >
                    <Button 
                        text={content.headerCallButtonName}
                        icon={<IconPhone />} 
                        hoverIcon={<IconPhoneYellow />}
                        type="secondary" 
                        mobiletextSmall = "yes"
                        mobileFull="yes"
                        onClick={() => {
                            setIsFormOpen(true);
                        }} 
                    />
                    <Button 
                        href={content.headerPriceButtonUrl}
                        text={content.headerPriceButtonName}
                        mobileFull="yes"
                        mobiletextSmall = "yes"
                        icon={<IconDocument />} 
                        type="primary"
                    />

                    {isFormOpen && (
                        <div 
                            className={`fixed  inset-0 flex items-center justify-center bg-[#00000033] z-10 transition-opacity duration-500 ease-in-out
                            ${isFormOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
                        >
                            <div 
                                className={`transform transition-transform duration-500 ease-in-out
                                ${isFormOpen ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}
                            >
                                <CallRequestForm onClose={() => setIsFormOpen(false)} lang={lang}/>
                            </div>
                        </div>
                    )}
                </div>

            </div>
            <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} global={global} content={content} menu={menu} />
        </header>
    )
}

export default HeaderContent